/* Nordika V5.3 · tónlist + fylgd. Nýtt skráarnafn 3.11.2026 (CDN-cache á nordika-v5.js hélt gamalli útgáfu). */

function bindNordikaMusic(root = document) {
  root.querySelectorAll('.nv5-audio').forEach((player) => {
    const button = player.querySelector('[data-nv5-play]');
    const audio = player.querySelector('audio');
    if (!button || !audio || button.dataset.bound) return;
    button.dataset.bound = 'true';
    button.hidden = false;
    audio.controls = false;
    audio.volume = 0.35;
    const icon = button.querySelector('[data-nv5-icon]');
    let pendingT = null;

    const render = () => {
      button.setAttribute('aria-pressed', String(!audio.paused));
      if (icon) icon.textContent = audio.paused ? '▶' : 'Ⅱ';
    };

    /* Forsókn: byrja að sækja lagið um leið og bendill eða fingur nálgast takkann. */
    const warm = () => {
      if (audio.preload !== 'auto') {
        audio.preload = 'auto';
        try { audio.load(); } catch (e) { /* ekkert */ }
      }
    };
    button.addEventListener('pointerenter', warm, { once: true });
    button.addEventListener('touchstart', warm, { once: true, passive: true });

    /* Hleðslustaða á takkanum meðan beðið er eftir hljóði. */
    audio.addEventListener('waiting', () => { if (!audio.paused && icon) icon.textContent = '…'; });
    audio.addEventListener('stalled', () => { if (!audio.paused && icon) icon.textContent = '…'; });
    audio.addEventListener('playing', render);

    /* Framhald milli síðna: ef sama lag var í gangi á síðustu síðu. */
    try {
      const saved = JSON.parse(sessionStorage.getItem('nv5-tonlist') || 'null');
      const srcEl = audio.querySelector('source');
      const mySrc = (srcEl && srcEl.src) || audio.currentSrc || '';
      if (saved && saved.src && mySrc && saved.src === mySrc && saved.playing && saved.t > 1) {
        pendingT = saved.t;
        button.classList.add('nv5-resume');
        button.title = 'Halda áfram þar sem frá var horfið';
      }
    } catch (e) { /* sessionStorage lokað */ }

    button.addEventListener('click', async () => {
      if (!audio.paused) { audio.pause(); return; }
      button.disabled = true;
      if (icon) icon.textContent = '…';
      try {
        await audio.play();
        if (pendingT != null && audio.duration && pendingT < audio.duration - 2) {
          audio.currentTime = pendingT;
        }
        pendingT = null;
        button.classList.remove('nv5-resume');
      } catch (e) {
        audio.controls = true;
        button.hidden = true;
      } finally {
        button.disabled = false;
        render();
      }
    });
    audio.addEventListener('play', render);
    audio.addEventListener('pause', () => { render(); saveMusicState(audio, false); });

    /* Vista stöðuna reglulega meðan spilað er. */
    let lastSave = 0;
    audio.addEventListener('timeupdate', () => {
      if (audio.paused) return;
      const now = Date.now();
      if (now - lastSave > 2000) { lastSave = now; saveMusicState(audio, true); }
    });
  });
}

function saveMusicState(audio, playing) {
  try {
    const srcEl = audio.querySelector('source');
    const src = (srcEl && srcEl.src) || audio.currentSrc || '';
    if (!src) return;
    sessionStorage.setItem('nv5-tonlist', JSON.stringify({ src: src, t: audio.currentTime || 0, playing: !!playing }));
  } catch (e) { /* ekkert */ }
}

/* Muted kynningarvídeó eiga að halda áfram að rúlla þó tónlist sé í gangi. */
function nudgeNordikaVideos() {
  document.querySelectorAll('video').forEach((v) => {
    if (!v.muted || !v.paused) return;
    const r = v.getBoundingClientRect();
    if (r.width === 0) return;
    const inView = r.bottom > 0 && r.top < (window.innerHeight || 0) + 200;
    if (inView) {
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    }
  });
}

bindNordikaMusic();
document.addEventListener('shopify:section:load', (event) => bindNordikaMusic(event.target));

/* Eitt hljóð í einu: nýtt ómútað hljóð pásar hin, og vídeóin fá hnipp á eftir. */
document.addEventListener('play', (event) => {
  if (!(event.target instanceof HTMLMediaElement)) return;
  if (event.target.muted) return;
  document.querySelectorAll('[data-nv5-audio]').forEach((media) => {
    if (media !== event.target) media.pause();
  });
  setTimeout(nudgeNordikaVideos, 400);
  setTimeout(nudgeNordikaVideos, 1600);
}, true);

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) setTimeout(nudgeNordikaVideos, 300);
});
window.addEventListener('pagehide', () => {
  const playing = Array.from(document.querySelectorAll('audio[data-nv5-audio]')).find((a) => !a.paused);
  if (playing) saveMusicState(playing, true);
});
